// extracted by mini-css-extract-plugin
export default {"wrap":"PricePackSingleComponent_wrap__5Nrcz","name":"PricePackSingleComponent_name__AJxy3","price":"PricePackSingleComponent_price__hCoQe"};